import { Loading } from "@doist/reactist";

const Spinner = () => {
    return <div className="mainSpinner"><Loading size="large" /></div>;
};

export default Spinner;